import { render, staticRenderFns } from "./SampleModal.vue?vue&type=template&id=0ca1dd3a&scoped=true"
import script from "./SampleModal.vue?vue&type=script&lang=js"
export * from "./SampleModal.vue?vue&type=script&lang=js"
import style0 from "./SampleModal.vue?vue&type=style&index=0&id=0ca1dd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca1dd3a",
  null
  
)

export default component.exports